import Resizer from "react-image-file-resizer";

//https://www.npmjs.com/package/react-image-file-resizer
export function ResizeImage(file: File, maxSize: number): Promise<File>{
  // let extension = file.type.split('/')[1];
  return new Promise((resolve) => {
    Resizer.imageFileResizer(file, maxSize, maxSize, 'JPEG', 90, 0, (resized) => {
      resolve(resized as File);
    }, "file"); // base64, blob or file
  });
}